/* eslint-disable */
import { PluginContainerData, Media, Link } from './common';
const baseImageData = {};
export const ImageData = {
    fromJSON(object) {
        const message = Object.assign({}, baseImageData);
        message.containerData =
            object.containerData !== undefined && object.containerData !== null
                ? PluginContainerData.fromJSON(object.containerData)
                : undefined;
        message.image =
            object.image !== undefined && object.image !== null
                ? Media.fromJSON(object.image)
                : undefined;
        message.link =
            object.link !== undefined && object.link !== null ? Link.fromJSON(object.link) : undefined;
        message.disableExpand =
            object.disableExpand !== undefined && object.disableExpand !== null
                ? Boolean(object.disableExpand)
                : undefined;
        message.altText =
            object.altText !== undefined && object.altText !== null ? String(object.altText) : undefined;
        message.caption =
            object.caption !== undefined && object.caption !== null ? String(object.caption) : undefined;
        message.disableDownload =
            object.disableDownload !== undefined && object.disableDownload !== null
                ? Boolean(object.disableDownload)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.containerData !== undefined &&
            (obj.containerData = message.containerData
                ? PluginContainerData.toJSON(message.containerData)
                : undefined);
        message.image !== undefined &&
            (obj.image = message.image ? Media.toJSON(message.image) : undefined);
        message.link !== undefined && (obj.link = message.link ? Link.toJSON(message.link) : undefined);
        message.disableExpand !== undefined && (obj.disableExpand = message.disableExpand);
        message.altText !== undefined && (obj.altText = message.altText);
        message.caption !== undefined && (obj.caption = message.caption);
        message.disableDownload !== undefined && (obj.disableDownload = message.disableDownload);
        return obj;
    },
};
//# sourceMappingURL=plugin_image.js.map